module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day01_05_stay-ee8c3508dd2c98dff463c22abaf68514.jpg";